import { gql } from '@apollo/client';

export const getDeferredMediaByIDsQuery = gql`
  query deferredShowPageMedias($sessionContext: SessionContext!, $ids: [String!]!) {
    medias(sessionContext: $sessionContext, ids: $ids) {
      id
      seasons {
        title
        id
        seasonNumber
        episodesCount
      }
      details {
        tabs {
          id
          tabLabel
          tabType
          tabContents {
            ...MediaMetadataData
            ...ContentMetadataData
            ...ContainerData
          }
        }
      }
    }
  }
  fragment MediaMetadataData on MediaMetadata {
    id
    title
  }
  fragment ContentMetadataData on ContentMetadata {
    id
    title
    duration {
      timeInSecs
      timeLabel
      timeAccessibilityLabel
      progressPercentage
      remainingTimeInSecs
      remainingTimeLabel
      remainingTimeAccessibilityLabel
      lastModifiedTimestamp
    }
    media {
      id
    }
  }
  fragment ContainerData on Container {
    id
    displayTitle
    style
    displayType
  }
`;
